import { render, staticRenderFns } from "./Milestones.vue?vue&type=template&id=130d2f7f&scoped=true"
import script from "./Milestones.vue?vue&type=script&lang=js"
export * from "./Milestones.vue?vue&type=script&lang=js"
import style0 from "./Milestones.vue?vue&type=style&index=0&id=130d2f7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d2f7f",
  null
  
)

export default component.exports